module.exports = __webpack_public_path__ + "img/bg1.874eabf7.png";